<template>
    <div class="notification-msg-container" :class="{'is-unread-container': message.state == 0}">
        <div class="icon-img-container">
            <img v-if="message.notification.data.properties.ThumbnailUrl" class="icon-img" alt="icon_img" :src="`${message.notification.data.properties.ThumbnailUrl}`">
            <img v-else-if="message.notification.data.properties.Category == 'BROADCAST'" class="icon-boardcast-img-svg" :icon-class="'broadcast'">
            <img v-else class="icon-img-svg" :icon-class="'empty_icon'" src="@/sharedAssets/img/logo/agrinome_logo_icon_round.png">
        </div>
        <div class="content-container">
            <div class="message-container">
                <p v-show="message.notification.data">{{ (((message.notification||{}).data||{}).properties||{}).Message || '---' }}</p>
                <span v-show="message.state == 0" class="is-read-indicator" />
            </div>
            <div class="datetime-container">
                <p :class="{'is-unread-msg': message.state == 0}">{{ formattedTime }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    props: {
        message: Object
    },
    computed: {
        formattedTime() {
            return moment(this.message.notification.creationTime).fromNow();
        }
    }
};
</script>

<style scoped>
.notification-msg-container {
    display: flex;
    width: 320px;
    align-items: center;
    padding: 8px 12px;
}

.icon-img-container {
    padding: var(--space-8);
    width: 52px;
    height: 52px;
    border: 1px solid #eeeeee;
    display: flex;
    border-radius: 8px;
    margin-right: 14px;
    background-color: #fafafa;
}
.icon-img{
    margin: auto;
    width: 100%;
    height: 100%;
}
.icon-img-svg{
    margin: auto;
    width: 18px;
    height: 18px;
}
.icon-boardcast-img-svg{
    margin: auto;
    width: 24px;
    height: 24px;
}
.content-container {
    flex: 3;
    display: flex;
    flex-direction: column;
    padding: 2px;
}
.message-container {
    flex: 3;
    display: flex;
    align-items: center;
}
.message-container p{
    flex: 3;
    font-size: 13px;
    color: var(--charcoal-black);
    margin: 0;
}
.datetime-container {
    flex: 1;
}
.datetime-container p {
    font-size: 11px;
    color: var(--description-grey);
}
.is-read-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: var(--danger);
    display: inline-block;
}
.is-unread-container {
    background-color: #f5f5f5;
}
.is-unread-msg {
    font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/Notification/NotificationMessageItem.vue